export default __webpack_public_path__ + "static/media/slab1.ec705105.png";